"use client";

import React, { useEffect } from "react";
import Script from "next/script";

import { GOOGLE_ANALYTICS_GA4_APPID, GTM_SCRIPT_ID } from "@constants/app-defaults";

import { gtmScript } from "@stadium/services/google-tag-manager";
import { OsanoConsentChangeHandler } from "@stadium/services/osano";
import useGA4Analytics from "@stadium/services/google-analytics";
import { useAuthContext } from "@stadium/hooks/lib/use-auth-wrapper";

const GlobalScripts = React.memo(({ staticPage }) => {
  const { axiosInterceptorAdded, graphqlInterceptorAdded } = useAuthContext();
  // Google Analytics GA4
  useGA4Analytics(GOOGLE_ANALYTICS_GA4_APPID);
  // End Google Analytics GA4

  /* Google Tag Manager */
  useEffect(() => {
    if (staticPage || (axiosInterceptorAdded && graphqlInterceptorAdded)) {
      gtmScript(GTM_SCRIPT_ID);
    }
  }, [axiosInterceptorAdded, graphqlInterceptorAdded, staticPage]);
  /* End Google Tag Manager */

  return (
    <>
      {process.env.NEXT_PUBLIC_ENVIRONMENT === "production" && <OsanoConsentChangeHandler />}
      {/* Schema Tag */}
      <Script type="application/ld+json" id="schema-tag" strategy="afterInteractive">
        {`
          {
            "@context": "https://schema.org",
            "@type": "Organization",
            "name": "Stadium",
            "url": "https://www.bystadium.com/",
            "logo": "https://images.prismic.io/snackmagic/e1062c14-6497-473f-bfde-5d48b5fed323_STADIUM_Logo_Color_WhiteBG+(1).png"
          }
        `}
      </Script>
      {/* End Schema Tag */}
      {/* Prismic Toolbar */}
      <Script
        id="prismic-script"
        src="https://static.cdn.prismic.io/prismic.js?repo=snackmagic&new=true"
        strategy="lazyOnload"
      />
      {/* End Prismic Toolbar */}
    </>
  );
});

export default GlobalScripts;
